const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    padding: '12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    gap: '16px',
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
  },

  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    margin: 0,
  },

  expandButton: {
    padding: '4px',
    color: 'var(--mcg-darkgray, #282F35)',
    '&:hover': {},
  },

  expandIcon: {
    fontSize: '20px',
    transition: 'transform 0.2s ease-in-out',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },

  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },

  fieldLabel: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    margin: 0,
  },

  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  collapse: {
    width: '100%',
  },
})

export default styles
